<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.optionType')"
    resource="option_types"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/option_types.js';
import { formColumnsExtend as optionValueFormColumnsExtend } from '../admin_entities/option_value_detail.js';

@Component
export default class OptionTypes extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'name_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'name',
      'option_values',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      {
        prop: 'option_values_attributes',
        label: this.$t('optionType.optionValuesAttributes'),
        renderCell: {
          component: 'nestForm',
          props: {
            columns: optionValueFormColumnsExtend([
              {
                key: 'name',
                renderCell: {
                  required: true
                }
              },
              {
                key: 'position',
                hint: '数值越小，优先级越高'
              }
            ], { data: data.option_values, type })
          },
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'option_types.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'option_types.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/option_types',
    name: 'option_types.index',
    component: OptionTypes,
    props: {
      type: 'index',
    }
  },
  {
    path: '/option_types/new',
    name: 'option_types.new',
    component: OptionTypes,
    props: {
      type: 'new',
    }
  },
  {
    path: '/option_types/:id',
    name: 'option_types.show',
    component: OptionTypes,
    props: {
      type: 'show',
    }
  },
  {
    path: '/option_types/:id/edit',
    name: 'option_types.edit',
    component: OptionTypes,
    props: {
      type: 'edit'
    }
  }
]
</script>
